module.exports = [{
      plugin: require('../node_modules/@chakra-ui/gatsby-plugin/gatsby-browser.js'),
      options: {"plugins":[],"resetCSS":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Angel Clinic International","short_name":"Angel Clinic International","start_url":"/","background_color":"#f7f0eb","theme_color":"#005884","display":"standalone","icon":"src/assets/logo/logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"d757aca05fcb7d5b7e008bc5ddc17d6e"},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"languages":["en","de","fr","it","ro","ru","tr"],"defaultLanguage":"en","siteUrl":"https://angelinternationalgroup.com","redirect":false,"generateDefaultLanguagePage":true,"i18nextOptions":{"fallbackLng":"en","supportedLngs":["en","de","fr","it","ro","ru","tr"],"defaultNS":"common","interpolation":{"escapeValue":false}}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
